var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isRequestingUnits && !_vm.getUnits.length
    ? _c(
        "section",
        [
          _vm._m(0),
          _vm._v(" "),
          _c("b-button", { on: { click: _vm.onClickAddUnit } }, [
            _vm._v(" Add Unit "),
          ]),
        ],
        1
      )
    : _c("section", [_c("pricing-scheduler")], 1)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mt-5 pt-4" }, [
      _vm._v("\n    You don't have any rental units yet."),
      _c("br"),
      _vm._v('Create your first one by\n    clicking "Add Unit."\n  '),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }